import { Market, MasterEvent, SelectionType, PickedEvent, Selection } from "../../../data";
import { Dictionary } from "sbtech-sports-data-api-client";

type MarketTypeOrderBySport = {
    football: SelectionType[],
    other: SelectionType[]
};

export class MarketGetter {

    private footballId: string = "1";
    private marketTypeOrderBySport: MarketTypeOrderBySport = {
        football: [SelectionType.ML, SelectionType.OU, SelectionType.HC],
        other: [SelectionType.ML, SelectionType.HC, SelectionType.OU]
    };

    /* Logic for market priorities */
    public getCurrentMarket(pickedEvent: PickedEvent): Market | undefined {
        if (pickedEvent.event) {
            let marketByPriority: Market | undefined = this.getMarketByPriorities(pickedEvent.event, this.getMarket(pickedEvent),
                this.getMarketsPriorityBySport(pickedEvent.event.sportID));
            return marketByPriority
                ? marketByPriority
                : this.getFailoverMarket(pickedEvent);

        }

        return undefined;
    }

    public getEmptyMarket(marketType: SelectionType): Market {
        return this.dummyMarkets[marketType];
    }

    private getFailoverMarket(pickedEvent: PickedEvent): Market | undefined {
        var failoverMarketType: SelectionType = pickedEvent.market ? pickedEvent.market.type : this.getMarket(pickedEvent);
        return this.dummyMarkets[failoverMarketType];
    }

    private getMarketByPriorities(event: MasterEvent, marketType: SelectionType, priorities: SelectionType[]): Market | undefined {
        for (let index: number = 0; index < event.markets.length; index++) {
            const market: Market = event.markets[index];
            if (market.type === marketType) {
                return market;
            }
        }

        if (event.markets.length === 0) {
            return this.getEmptyMarket(marketType);
        }

        return this.getMarketByPriority(event.markets, priorities);

    }

    private getMarketByPriority(markets:Market[], priorities:SelectionType[]):Market | undefined {
        for (let i = 0; i < priorities.length; i++) {
            const currentMarketType: SelectionType = priorities[i];

            for (let j = 0; j < markets.length; j++) {
                const market: Market = markets[j];

                if (market.type === currentMarketType) {
                    return market;
                }
            }
        }
        return undefined;
    }

    private getMarketsPriorityBySport(sportId: string): SelectionType[] {
        if (sportId === this.footballId) {
            return this.marketTypeOrderBySport.football;
        }
        return this.marketTypeOrderBySport.other;
    }

    private getMarket(event: PickedEvent): SelectionType {

        if (event.IsQA || event.IsOutright) {
            return SelectionType.QA;
        }

        switch (event.LineTypeID) {
            case 1:
                return SelectionType.ML;
            case 2:
                return SelectionType.HC;
            case 3:
                return SelectionType.OU;
            default:
                throw new Error("missing id for selection type");
        }
    }

    private dummyMarkets: Dictionary<Market> = {
        ML: new Market({
            id: "1",
            name: "",
            type: SelectionType.ML,
            typeId: "",
            selections: [this.getDisabledDummySelection("1"),
            this.getDisabledDummySelection("2"),
            this.getDisabledDummySelection("3")]
        }),
        HC: new Market({
            id: "1",
            name: "",
            type: SelectionType.HC,
            typeId: "",
            selections: [this.getDisabledDummySelection("1"),
            this.getDisabledDummySelection("2")]
        }),
        OU: new Market({
            id: "1",
            name: "",
            type: SelectionType.OU,
            typeId: "",
            selections: [this.getDisabledDummySelection("1"),
            this.getDisabledDummySelection("2")]
        }),
        QA: new Market({
            id: "1",
            name: "",
            type: SelectionType.QA,
            typeId: "",
            selections: [this.getDisabledDummySelection("1"),
            this.getDisabledDummySelection("2")]
        })
    };

    private getDisabledDummySelection(_id: string): Selection {
        return new Selection({
            id: _id,
            title: "",
            points: 0,
            odds: "",
            lineGroupId: "",
            displayOdds: { decimal: "0" },
            isDisabled: true,
            isSelected: false,
            isSwapped: false,
            sbtechId: "",
            outcomeType: ""
        });
    }
}